import {
  revitLayersItem,
} from './revitlayers-helpers';

import imagesLoaded from 'imagesloaded';
import jQuery from 'jquery';

export function revitLayers($container, location) {

   console.log("revitLayers");
  if (location == "single-projects") {
    // console.log("single-projects");

  } else if (location == "archive-projects") {

    // console.log("archive-projects");

  } else if (location == "home-page") {
  console.log("home-page revit Layers");

  } else if (location == "single-clients") {
    // console.log("single clients revit");

  }

  if ($container.find(".revitlayers__container").length) {


    console.log("revitlayers__container exists");

    var $revitLayersContainers = $container.find(".revitlayers__container");
   
    $revitLayersContainers.each(function () {

  console.log("each revitlayers container");


      var $revitLayersContainer = $(this);
       $revitLayersContainer.imagesLoaded({
          // options...
        },
        function () {

          console.log("images loaded");
          // $revitLayersContainer.css("background", "green");
          revitLayersItem($revitLayersContainer)
        }

      ); // 

    }); // each container

  } //if slider exists

  console.log("revitLayers done");

} //export default function init()